import { render, staticRenderFns } from "./RecruiterQaCompose.vue?vue&type=template&id=53add70c&scoped=true"
import script from "./RecruiterQaCompose.vue?vue&type=script&lang=js"
export * from "./RecruiterQaCompose.vue?vue&type=script&lang=js"
import style0 from "./RecruiterQaCompose.vue?vue&type=style&index=0&id=53add70c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53add70c",
  null
  
)

export default component.exports